import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQueryParams(queryParams: string | string[] | null = null) {
  const location = useLocation();

  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  if (queryParams === null) {
    const allParams: Record<string, string> = {};
    for (const [key, value] of searchParams.entries()) {
      allParams[key] = value;
    }
    return allParams;
  }

  if (typeof queryParams === 'string') {
    return { [queryParams]: searchParams.get(queryParams) };
  }

  if (Array.isArray(queryParams)) {
    const result: Record<string, string | null> = {};
    for (const queryParam of queryParams) {
      result[queryParam] = searchParams.get(queryParam);
    }
    return result;
  }
  return {};
}
